var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 10.5003C18.3334 15.1027 14.6025 18.8337 10.0001 18.8337C5.39771 18.8337 1.66675 15.1027 1.66675 10.5003C1.66675 5.89795 5.39771 2.16699 10.0001 2.16699C14.6025 2.16699 18.3334 5.89795 18.3334 10.5003ZM13.6882 9.18723C13.8834 8.99197 13.8834 8.67539 13.6882 8.48013C13.4929 8.28486 13.1763 8.28486 12.9811 8.48013L9.16789 12.2933L7.02057 10.1467C6.82527 9.9515 6.50869 9.95156 6.31346 10.1469C6.11823 10.3422 6.11829 10.6587 6.31358 10.854L8.81446 13.354C9.00973 13.5492 9.32627 13.5491 9.5215 13.3539L13.6882 9.18723Z",
    fill: "#01463A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertConfirmed);
export default __webpack_public_path__ + "static/media/AlertConfirmed.1509720a5f0efe8cc2668474a3679963.svg";
export { ForwardRef as ReactComponent };